import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ToolTip from '../Tooltip';
import InfoIcon from '@pixel/assets/icons/Info';
import SuccessIcon from '@pixel/assets/icons/Success';
import ErrorIcon from '@pixel/assets/icons/Error';
import WarningIcon from '@pixel/assets/icons/Warning';
const PREFIX = 'StatusScreen';
const classes = {
  progress: "".concat(PREFIX, "-progress"),
  paper: "".concat(PREFIX, "-paper"),
  iconContainer: "".concat(PREFIX, "-iconContainer"),
  icon: "".concat(PREFIX, "-icon"),
  iconSmall: "".concat(PREFIX, "-iconSmall"),
  iconTiny: "".concat(PREFIX, "-iconTiny"),
  iconMedium: "".concat(PREFIX, "-iconMedium"),
  iconContainerSmall: "".concat(PREFIX, "-iconContainerSmall"),
  iconContainerTiny: "".concat(PREFIX, "-iconContainerTiny"),
  iconContainerMedium: "".concat(PREFIX, "-iconContainerMedium")
};
const Root = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    ["&.".concat(classes.progress)]: {
      maxWidth: 800,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    ["& .".concat(classes.paper)]: {
      padding: theme.spacing(2)
    },
    ["& .".concat(classes.iconContainer)]: {
      width: iconSize,
      marginTop: 0,
      marginBottom: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    ["& .".concat(classes.iconContainerMedium)]: {
      width: iconSize,
      marginTop: 0,
      marginBottom: theme.spacing(0.5),
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    ["& .".concat(classes.icon)]: {
      height: iconSize,
      width: iconSize
    },
    ["& .".concat(classes.iconSmall)]: {
      height: iconSizeSmall,
      width: iconSizeSmall
    },
    ["& .".concat(classes.iconTiny)]: {
      height: iconSizeTiny,
      width: iconSizeTiny
    },
    ["& .".concat(classes.iconMedium)]: {
      height: iconSizeMedium,
      width: iconSizeMedium
    }
  };
});
const iconSize = 50;
const iconSizeSmall = 24;
const iconSizeTiny = 20;
const iconSizeMedium = 32;
const iconMap = {
  error: ErrorIcon,
  warning: WarningIcon,
  success: SuccessIcon,
  info: InfoIcon
};
const ErrorScreen = _ref2 => {
  let {
    title = 'Error',
    text = null,
    type = 'error',
    size = "large"
  } = _ref2;
  const types = ['error', 'warning', 'success', 'info'];
  if (!types.includes(type)) {
    console.error("ErrorScreen: type must be one of 'error', 'warning', 'success', 'info'");
    type = 'error';
  }
  const color = 'error'; //typography color is already mapped to these types
  const Icon = iconMap[type];

  // todo style and code size variations
  console.error("ErrorScreen", title, text);
  return /*#__PURE__*/React.createElement(Root, {
    className: classes.progress
  }, size == "large" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    color: color,
    className: classes.icon
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "error",
    align: "center"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    align: "center"
  }, text)), size == "medium" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainerMedium
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "error",
    className: classes.iconMedium
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "error",
    align: "center"
  }, title)), size == "small" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainerSmall
  }, /*#__PURE__*/React.createElement(ToolTip, {
    title: title
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "error",
    className: classes.iconSmall
  })))), size == "small" && /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainerTiny
  }, /*#__PURE__*/React.createElement(ToolTip, {
    title: title
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "error",
    className: classes.iconTiny
  }))));
};
export default ErrorScreen;